<div [class]="[computedLayoutDirection(), 'detail-popup-section-header']" fxLayoutGap="4px">
  <div [style]="{ color: color() ?? '' }" class="capitalize-first-letter detail-popup-section-header__title fw-600">{{ headerTitle() }}</div>
  <ng-content />
  @if (loading()) {
    <mat-progress-spinner [diameter]="20" color="accent" mode="indeterminate" />
  }
  <div [style]="{ borderColor: color() ?? '' }" class="separation-line" fxFlex></div>
</div>
